var map = {
	"../pages/choose-opponent/choose-opponent.module": [
		315,
		7
	],
	"../pages/join-game/join-game.module": [
		316,
		6
	],
	"../pages/quiz-result/quiz-result.module": [
		317,
		5
	],
	"../pages/response-result/response-result.module": [
		318,
		4
	],
	"../pages/select-answer/select-answer.module": [
		319,
		3
	],
	"../pages/select-question/select-question.module": [
		320,
		2
	],
	"../pages/start-game/start-game.module": [
		321,
		1
	],
	"../pages/waiting/waiting.module": [
		322,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 223;



//////////////////
// WEBPACK FOOTER
// ./src async
// module id = 223
// module chunks = 8